import { Link } from 'react-router-dom'
import { Logo } from './Logo'

/** Logo à esquerda, "Minhas consultas" e "Já paguei" à direita. */
export function SiteHeader() {
  return (
    <header className="border-b border-border bg-background">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-3 px-4 py-3.5">
        <Link to="/" aria-label="Origem Veicular — início" className="shrink-0">
          <Logo className="h-7 sm:h-9" />
        </Link>

        <nav className="flex items-center gap-3 text-sm font-semibold sm:gap-6">
          <Link to="/minhas-consultas" className="text-foreground hover:text-brand">
            Minhas consultas
          </Link>
          {/* "Já paguei" leva à mesma entrada por e-mail de Minhas consultas. */}
          <Link to="/ja-paguei" className="text-foreground hover:text-brand">
            Já paguei
          </Link>
        </nav>
      </div>
    </header>
  )
}
